import { Component, input, output } from '@angular/core';

@Component({
    selector: 'app-numeric-keyboard',
    templateUrl: 'numeric-keyboard.component.html',
    styleUrls: ['./numeric-keyboard.component.scss'],
    imports: [],
})
export class NumericKeyboardComponent {
    controlName = input<string>('');
    cvvMaxLength = input<number>(3);
    currentValue = input<string>('');
    returnValue = output<any>();
    keyboardStatus = output<boolean>();
    keys = [
        //numeric keyboard allowed keys
        [
            ['1', '1'],
            ['2', '2'],
            ['3', '3'],
            ['4', '4'],
            ['5', '5'],
            ['.', '.'],
            ['Ok', 'Ok'],
        ],
        [
            ['6', '6'],
            ['7', '7'],
            ['8', '8'],
            ['9', '9'],
            ['0', '0'],
            ['Bksp', 'Bksp'],
        ],
    ];

    pressed(event: any, key: any) {
        const controlName = this.controlName();
        let currentValue = this.currentValue();
        //event handler for key press
        let element: any,
            contentsBeforeCursor = '',
            contentsAfterCursor = '';
        if (controlName === 'amount') {
            element = document.getElementById('userAmount');
        } else if (controlName === 'cvv2') {
            element = document.getElementById('cvv2');
        }
        const caretPosition = element?.selectionStart; //to get the cursor position of the input field
        currentValue = currentValue?.slice(0, element?.selectionStart) + currentValue?.slice(element?.selectionEnd);
        if (typeof caretPosition !== 'undefined') {
            contentsBeforeCursor = currentValue?.substring(0, caretPosition);
            contentsAfterCursor = currentValue?.substring(caretPosition, currentValue?.length);
        }
        event.preventDefault();
        switch (key[0]) {
            case 'Bksp':
                if (typeof caretPosition !== 'undefined') {
                    if (element?.selectionStart === element?.selectionEnd) {
                        const newVal = contentsBeforeCursor?.slice(0, -1) + contentsAfterCursor || '';
                        this.returnValue.emit(newVal);
                        setTimeout(() => {
                            element.focus();
                            element.setSelectionRange(caretPosition - 1, caretPosition - 1);
                        }, 0);
                        currentValue = newVal;
                    } else {
                        this.returnValue.emit(currentValue);
                        setTimeout(() => {
                            element.focus();
                            element.setSelectionRange(caretPosition, caretPosition);
                        }, 0);
                    }
                } else {
                    if (window?.getSelection()?.toString()) {
                        currentValue = '';
                    } else {
                        currentValue = (currentValue || '').slice(0, -1);
                    }
                    setTimeout(() => {
                        element.focus();
                    }, 0);
                }
                break;

            case 'Ok':
                this.keyboardStatus.emit(true);
                element.blur();
                break;

            default:
                if ((key[0] === '.' && controlName === 'cvv2') || currentValue.length >= this.cvvMaxLength()) {
                    // preventing entering "." and restrict on maxlength on the cvv field
                    this.returnValue.emit(currentValue);
                } else {
                    const regExp = /^[0-9]+([.]?[0-9]{0,2})?$/;
                    if (typeof caretPosition !== 'undefined') {
                        const newVal = contentsBeforeCursor + key[0] + contentsAfterCursor || '';
                        setTimeout(() => {
                            element.focus();
                            element.setSelectionRange(caretPosition + 1, caretPosition + 1);
                        }, 0);
                        if (!newVal.match(regExp) && controlName === 'amount') {
                            this.returnValue.emit(currentValue);
                        } else {
                            this.returnValue.emit(newVal);
                            currentValue = newVal;
                        }
                    } else {
                        if (window?.getSelection()?.toString()) {
                            currentValue = key[0];
                        } else {
                            const newVal = (currentValue || '') + key[0];
                            if (controlName === 'amount' && !newVal.match(regExp)) {
                                this.returnValue.emit(currentValue);
                            } else {
                                this.returnValue.emit(newVal);
                                currentValue = newVal;
                            }
                        }
                    }
                }
                break;
        }
    }
}
